interface Props {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * 案内画面。
 * フロー図の「このイベントへの参加には LINE アプリが必要です」をはじめ、
 * トークン期限切れ・イベント未開催などの終端表示に使う。
 */
export function NoticeScreen({ title, body, actionLabel, onAction }: Props): JSX.Element {
  return (
    <div className="card center">
      <h1>{title}</h1>
      <p>{body}</p>
      {actionLabel && onAction && (
        <button type="button" className="btn btn--ghost" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}

/** エラーコードを利用者向けの文言に変換する */
export function describeError(code: string): { title: string; body: string } {
  switch (code) {
    case 'INVALID_TOKEN':
    case 'COCODEPIT_NG':
      return {
        title: 'もう一度タッチしてください',
        body: 'このURLは無効です。店内のココデピットにもう一度スマホをタッチしてください。',
      };
    case 'EXPIRED_TOKEN':
    case 'TOUCH_EXPIRED':
      return {
        title: '有効期限が切れました',
        body: '時間が経過したため無効になりました。店内のココデピットにもう一度タッチしてください。',
      };
    case 'REUSED_TOKEN':
      return {
        title: 'このURLは使用済みです',
        body: '店内のココデピットにもう一度スマホをタッチしてください。',
      };
    case 'UNKNOWN_DEVICE':
      return {
        title: 'ご利用いただけません',
        body: 'この設置場所は現在ご利用いただけません。スタッフにお声がけください。',
      };
    case 'NO_ACTIVE_EVENT':
    case 'EVENT_NOT_PUBLISHED':
    case 'OUT_OF_PERIOD':
      return {
        title: '現在開催中のイベントはありません',
        body: '次回の開催をお楽しみに。',
      };
    case 'ALREADY_ENTERED_TODAY':
      return {
        title: '本日はご参加済みです',
        body: 'このイベントは1日1回までご参加いただけます。またのご来店をお待ちしております。',
      };
    case 'ALREADY_ENTERED_PERIOD':
      return {
        title: 'ご参加済みです',
        body: 'このイベントは期間中1回までご参加いただけます。',
      };
    case 'ENTRY_EXPIRED':
      return {
        title: '特典の受け取り期限が切れました',
        body: '当選から時間が経過したため、この特典は受け取れなくなりました。またのご参加をお待ちしております。',
      };
    case 'TOUCH_CONSUMED':
      return {
        title: 'この抽選は終了しています',
        body: 'もう一度参加する場合は、店内のココデピットにもう一度タッチしてください。',
      };
    case 'NO_SESSION':
      return {
        title: 'ココデピットにタッチしてください',
        body: '店内に設置されたココデピットにスマホをタッチすると、イベントに参加できます。',
      };
    default:
      return {
        title: 'エラーが発生しました',
        body: '時間をおいて、店内のココデピットにもう一度タッチしてください。',
      };
  }
}
